<template>
    <div class="rp-helpdesk-conversation-message-gif">
        <div class="rp-helpdesk-conversation-message-box-gif">
            <div
                class="rp-helpdesk-conversation-message-box-gif-bg"
                :style="{ backgroundImage: `url(${url})` }" />
        </div>
    </div>
</template>

<script>

export default {
    
    props: {

        message: {
            type: Object,
            required: true
        }

    },

    computed: {

        url() {
            return this.message.mediaValue;
        }

    }

}

</script>

<style lang="scss">

.rp-helpdesk-conversation-message-box-gif {
    @include square(200px);
    display: inline-block;

    &.from-operator {
        text-align: right;
    }

    &.from-customer {
        text-align: left;
    }
}

.rp-helpdesk-conversation-message-box-gif-bg {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    border-radius: 5px;
}

</style>
